import styled from "styled-components";

const StyledVideoWrapper = styled.div`
  width: 100%;
  padding-bottom: 56.25%;
  // position: relative;
`;

export default StyledVideoWrapper;
